import { render, staticRenderFns } from "./feedAdd.vue?vue&type=template&id=1c22933e&scoped=true"
import script from "./feedAdd.vue?vue&type=script&lang=js"
export * from "./feedAdd.vue?vue&type=script&lang=js"
import style0 from "./feedAdd.vue?vue&type=style&index=0&id=1c22933e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c22933e",
  null
  
)

export default component.exports